const buildTransformableUrl = (path, urlTransform) => {
  if (urlTransform) {
    return urlTransform(path);
  }

  return path;
};

export const getDemographicsUrl = urlTransform => buildTransformableUrl('/demographics/v1', urlTransform);
export const getDemographicsUserUrl = urlTransform => buildTransformableUrl('/demographics/v1/user', urlTransform);
export const getDemographicsPortalUrl = urlTransform => buildTransformableUrl('/demographics/v1/portal', urlTransform);